import ParticipantsACHPage from "components/pages/ParticipantsACHPage";

export default function CaptureACHParticipantsMain(props) {
    return <ParticipantsACHPage/>
}